import { GetResponseAnswerData } from '../../../Common/Commands'
import { SurveyEngine_Models_Answer, SurveyEngine_Models_BaseResponse, SurveyEngine_Models_GetResponseResponse, SurveyEngine_Models_ScaleResponse } from '../../../api'
import { GetResponse } from '../GetResponse/GetResponse'

interface ScaleProps {
  id:number
  message:string,
  answers:SurveyEngine_Models_Answer[]
  defaultAnswer:string
  layout: string
  isError:boolean
  focus:boolean
  callback: (response: SurveyEngine_Models_BaseResponse) => void
}

export const Scale = (props:ScaleProps) => {
 
  const transformResponse = (response: SurveyEngine_Models_GetResponseResponse) => {
 
    if(response)
    {
      let res:SurveyEngine_Models_ScaleResponse = {
        commandIndex:response.commandIndex,
        //should not override if command type is "Remove"
        commandType: response.commandType?.toLocaleLowerCase() === 'remove' ? "Remove" : "Scale",
        selectedId:response.selectedId
      }
      props.callback(res);
    }

  }

  const transformAnswers = () => {
 
    let data:GetResponseAnswerData[] = props.answers.map(
      (item: SurveyEngine_Models_Answer) => {

        let answer:GetResponseAnswerData = {
          label: item.message??item.id!.toString()!,
          value: item.id!,
          isOpenEnded:false,
          otherValue:""
        }
        return answer;
      });
      return data;
  }

  return (
    <GetResponse id={props.id}
    question={props.message}
    answers={transformAnswers()}
    defaultAnswer={props.defaultAnswer}
    layout={props.layout}
    isError={props.isError} focus={props.focus}
    callback={transformResponse}></GetResponse>
  );
}
